/**
 * forceConsent.ts — WEB-1820.
 *
 * ЗАЧЕМ. Баннер согласия показывается только посетителям из ЕС/Норвегии/
 * Исландии/Лихтенштейна/Великобритании (`euConsent.requiresEuConsent`,
 * гео сервера). QA трижды не смог проверить его живьём: браузерные дорожки
 * автоматизации выходят в сеть не из этого списка стран, и живьём это не
 * подделать никаким браузером — гео решает сервер по `cf-ipcountry`.
 *
 * Служебный параметр адреса `?forceConsent=1` обходит гео-условие ТОЛЬКО на
 * хостах стенда платформы (`isStagingConsentHost`, `config/publicEntryHosts.ts`
 * — apex/поддомены/localhost). На купленном клиентском домене (реальный
 * трафик покупателя, в т.ч. домены, купленные QA специально для тестов) и,
 * значит, в бою параметр игнорируется вовсе — по устройству хоста, а не по
 * значению: это не секрет, который можно узнать и подставить где угодно.
 *
 * НИЧЕГО НЕ ПИШЕТ. Ни куки, ни localStorage — решение живёт только в
 * адресной строке текущей вкладки. Уйти со стенда без параметра означает
 * немедленно вернуться к обычному гео-правилу; ничего не переживает переход.
 */
import { isStagingConsentHost } from '@/config/publicEntryHosts';

export function isForceConsentActive(
  forceConsentParam: string | null,
  host: string,
  apex: string,
): boolean {
  if (!isStagingConsentHost(host, apex)) return false;
  return forceConsentParam === '1';
}
